import React from 'react';
import {
  FormControlLabel,
  Checkbox,
  FormHelperText,
  FormControl,
} from '@mui/material';
import withStyles from '@mui/styles/withStyles';

interface CheckboxComponentProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  labelComponent?: React.ReactNode;
  hasError?: boolean;
  errorMessage?: string;
  input?: {
    value: boolean;
    onChange: (value: boolean) => void;
  };
  onFieldChange?: (checked: boolean) => void;
  onTextFieldChange?: (checked: boolean) => void;
  [key: string]: any;
}

const ErrorCheckbox = withStyles({
  root: {
    color: '#f44336',
  },
})((props: React.ComponentProps<typeof Checkbox>) => <Checkbox color="default" {...props} />);

const CheckboxComponent: React.FC<CheckboxComponentProps> = ({
  checked,
  onChange = () => {},
  labelComponent,
  hasError,
  errorMessage,
  input,
  onFieldChange,
  onTextFieldChange,
  ...props
}) => {
  const RenderedCheckbox = hasError ? <ErrorCheckbox /> : <Checkbox style={{ color: "#2a81e8" }} />;

  return (
    <FormControl error={hasError}>
      <FormControlLabel
        control={RenderedCheckbox}
        onChange={(event) => {
          const isChecked = (event.target as HTMLInputElement).checked;
          onChange(isChecked);
          if (props.onFieldChange) { props.onFieldChange(isChecked); }
          if (props.onTextFieldChange) { props.onTextFieldChange(isChecked); }
          props.input?.onChange(isChecked);
        }}
        checked={checked === undefined ? input?.value : checked}
        label={labelComponent}
        {...props}
      />
      {hasError ? (
        <FormHelperText className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error">
          {errorMessage}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default CheckboxComponent;
